module.exports = __webpack_public_path__ + "static/media/moto_4.064e7d25.png";